import api from '../api'

const baseUrl = '/academy/api/Advertising'

const dadbananAdvertisingProvider = {
  addAdvertising(payload) {
    return api.post(`${baseUrl}/Add`, payload)
  },
  addExcel(payload) {
    return api.post(`/academy/api/AdminCourse/InsertJobAdvertisings`, payload)
  },
  updateAdvertising(payload) {
    return api.post(`${baseUrl}/Update`, payload)
  },
  getById(id) {
    return api.get(`${baseUrl}/GetById?Id=${id}`)
  },
  getByCode(code) {
    return api.get(`${baseUrl}/GetByAdvertisingCode?Code=${code}`)
  },
  getNewAdvertisings() {
    return api.get(`${baseUrl}/GetNewAdvertisings`)
  },
}

export default dadbananAdvertisingProvider
